import { DATA_SOURCES } from '@/config/constants';
import { isDataSupported } from '../utils';
import { useGoogleData } from 'utils/hooks';
import { useGoogleDataMapped } from 'utils/hooks/useGoogleData';
import { v5 as uuidv5 } from 'uuid';

const mapIds = (arr, key) => arr?.map((obj) => obj[key]) || [];

export const useSearchWatchlistData = ({
    brandIds,
    categoryIds,
    affinityCategoryIds,
    affinityBrandIds,
    countryId,
    country,
}) => {
    const brandsQuery = useGoogleData({
        enabled: !!(brandIds && countryId),
        data: {
            brands: brandIds,
            countries: [countryId],
        },
        paginateBy: 'brands',
        minimal: true,
    });

    const categoriesQuery = useGoogleData({
        enabled: !!(categoryIds && countryId),
        data: {
            categories: categoryIds,
            countries: [countryId],
        },
        paginateBy: 'categories',
        minimal: true,
    });

    const categoryAffinitiesQuery = useGoogleDataMapped({
        enabled: !!(affinityCategoryIds?.length && countryId),
        data: {
            categories: mapIds(affinityCategoryIds, 'categoryId'),
            affinities: mapIds(affinityCategoryIds, 'affinityId'),
            countries: [countryId],
            get_parent_trend_name: true,
        },
        paginateBy: 'affinities',
        get_parent_trend_name: true,
    });

    const brandAffinitiesQuery = useGoogleDataMapped({
        enabled: !!(affinityBrandIds?.length && countryId),
        data: {
            brands: mapIds(affinityBrandIds, 'brandId'),
            affinities: mapIds(affinityBrandIds, 'affinityId'),
            countries: [countryId],
            get_parent_trend_name: true,
        },
        paginateBy: 'affinities',
        get_parent_trend_name: true,
    });

    const allSearchData = [
        ...(brandsQuery.data || []),
        ...(categoriesQuery.data || []),
        ...(categoryAffinitiesQuery.data?.map((a) => ({
            ...a,
            affinityId: a.id,
            id: uuidv5(a.categoryId, a.id),
            type: 'affinity',
            exportName: `${a.parent_trend_name} - ${a.name}`,
        })) || []),
        ...(brandAffinitiesQuery.data?.map((a) => ({
            ...a,
            affinityId: a.id,
            id: uuidv5(a.brandId, a.id),
            type: 'affinity',
            exportName: `${a.parent_trend_name} - ${a.name}`,
        })) || []),
    ].filter((d) => isDataSupported(d, country, DATA_SOURCES.GOOGLE));

    return {
        brandsQuery,
        categoriesQuery,
        categoryAffinitiesQuery,
        brandAffinitiesQuery,
        allSearchData,
    };
};
